/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_No_Project_File_SelectedInputs */



/**
* | output |
* | --- |
* | "Error - No project file selected" |
*
* @param {Error_No_Project_File_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_no_project_file_selected = /** @type {((inputs?: Error_No_Project_File_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_No_Project_File_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur - Aucun fichier de projet sélectionné")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler – Keine Projektdatei ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore - Nessun file di progetto selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка — не выбран файл проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error: No hay ningún archivo de proyecto seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("错误 - 未选择项目文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エラー - プロジェクト ファイルが選択されていません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("त्रुटि - कोई प्रोजेक्ट फ़ाइल चयनित नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro - Nenhum arquivo de projeto selecionado")
	return /** @type {LocalizedString} */ ("Error - No project file selected")
});